import styled from 'styled-components';

import { Headline as InnerHeadline } from '@xing-com/typography';

import { FollowButton as InnerFollowButton } from '../follow-button';

export const Headline = styled(InnerHeadline)<$TSFixMe>`
  margin: var(--spaceXL) 0 var(--spaceL) 0;
  &.industry-company-headline {
    margin: var(--spaceXL) 0 var(--spaceXXL) 0;
  }
`;

export const FollowButton = styled(InnerFollowButton)`
  margin-left: auto;
`;
